module.exports = __webpack_public_path__ + "static/media/marksman-logo-small-staging.44feaa1b.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/marksman-logo-small-staging.png
// module id = 934
// module chunks = 0